export default "__VITE_PUBLIC_ASSET__abd388b8__"